(function(){
  'use strict';

  const root=document.getElementById('custom-coin-tool');
  if(!root) return;

  const $=(sel,ctx=root)=>ctx.querySelector(sel);
  const $$=(sel,ctx=root)=>Array.from(ctx.querySelectorAll(sel));
  const productHandle=root.dataset.productHandle||'40mm-barons-coin™-custom';

  const PATTERNS={
    none:{pattern:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/none.png?v=1763738655',overlay:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/none-overlay.png?v=1763738655',maxColors:1},
    stripe:{pattern:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/stripe-01.png?v=1764012046',overlay:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/stripe-OL-01.png?v=1764012046',maxColors:3},
    scale:{pattern:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/scale-01.png?v=1764012046',overlay:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/scale-OL-01.png?v=1764012046',maxColors:3},
    brick:{pattern:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/brick-01.png?v=1764012046',overlay:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/brick-OL-01.png?v=1764012046',maxColors:3},
    diamond:{pattern:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/diamond-01.png?v=1764012046',overlay:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/diamond-OL-01.png?v=1764012046',maxColors:3},
    shatter:{pattern:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/shatter-01.png?v=1764012046',overlay:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/shatter-OL-01.png?v=1764012046',maxColors:3},
    tech:{pattern:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/tech-01.png?v=1764012046',overlay:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/tech-OL-01.png?v=1764012046',maxColors:3},
    circuit:{pattern:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/tech-01.png?v=1764012046',overlay:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/tech-OL-01.png?v=1764012046',maxColors:3},
    cross:{pattern:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/cross-01.png?v=1764012046',overlay:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/cross-OL-01.png?v=1764012046',maxColors:3},
    dawn:{pattern:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/dawn-01.png?v=1764012046',overlay:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/dawn-OL-01.png?v=1764012046',maxColors:3},
    tri:{pattern:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/tri-01.png?v=1764012046',overlay:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/tri-OL-01.png?v=1764012046',maxColors:3},
    flux:{pattern:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/flux-01.png?v=1764621298',overlay:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/flux_OL-01.png?v=1764621298',maxColors:3},
    web:{pattern:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/web-01.png?v=1764621298',overlay:'//cdn.shopify.com/s/files/1/0549/1379/4157/files/web_OL-01.png?v=1764621298',maxColors:3}
  };

  const DEFAULT_LOGO='//baronofdice.com/cdn/shop/files/bod_default_logo.png?v=1763738548';

  const state={
    product:'Custom Coin',diameter:'40mm',thickness:'3mm',
    metal:'Brass',metalColor:'#b19e69',
    pattern:'Shatter',patternKey:'shatter',patternRotate:0,
    baseNoPaint:false,logoNoPaint:false,
    backgroundToneCount:3,tone1:'#455e58',tone2:'#3e2323',tone3:'#484e5b',
    toneNone:[false,false,false],rgbColors:['#455e58','#3e2323','#484e5b'],rgbNone:[false,false,false],
    logoColorCount:2,logoColors:['#ffc400','#f4ecd7'],logoNone:[false,false],
    logoScale:135,logoThreshold:125,logoFileName:'BOD Logo',logoImage:null,
    backgroundImage:null,backgroundOverlay:null,quantity:null,variant:null,accessories:['None']
  };

  const store=window.__product_customCoins=window.__product_customCoins||{_base:null,_quantities:[],_product:null};

  const el={
    form:$('#customCoinForm'),preview:$('#ccCoinPreview'),patternSpin:$('#ccPatternSpin'),
    bgCanvas:$('#ccBackgroundCanvas'),bgOverlay:$('#ccPatternOverlay'),
    logoCanvas:$('#ccLogoCanvas'),logoFallback:$('#ccLogoFallback'),
    logoUpload:$('#cc-logo-upload'),logoFileName:$('#ccLogoFileName'),
    logoScale:$('#cc-logo-scale'),logoScaleLabel:$('#ccLogoScaleLabel'),
    logoThreshold:$('#cc-logo-threshold'),logoThresholdLabel:$('#ccLogoThresholdLabel'),logoThresholdWrap:$('#ccLogoThresholdWrap'),
    patternRotate:$('#patternRotate'),patternRotateLabel:$('#txt-patternRotate'),
    qty:$('#qty'),qtyLabel:$('#qty-label'),qtyDatalist:$('#ccQtyLabels'),qtyMilestones:$('#ccQtyMilestones'),
    price:$('#coin-price-label'),panelPrice:$('#coin-price-label-panel'),
    mobileQty:$('#ccMobileQty'),mobilePrice:$('#ccMobilePrice'),status:$('#ccStatus'),
    summaryMetal:$('#ccSummaryMetal'),summaryPattern:$('#ccSummaryPattern'),summaryQty:$('#ccSummaryQty'),
    cartMetal:$('#ccCartMetal'),cartPattern:$('#ccCartPattern'),cartLogoScale:$('#ccCartLogoScale'),cartPrice:$('#ccCartPrice'),
    propMetal:$('#cc-property-metal'),propPattern:$('#cc-property-pattern'),propBasePaint:$('#cc-property-base-paint'),
    propPatternColorCount:$('#cc-property-pattern-color-count'),propPatternColors:$('#cc-property-pattern-colors'),
    propLogoPaint:$('#cc-property-logo-paint'),propLogoColorCount:$('#cc-property-logo-color-count'),propLogoColors:$('#cc-property-logo-colors'),
    propLogoScale:$('#cc-property-logo-scale'),propLogoThreshold:$('#cc-property-logo-threshold'),propLogoFileName:$('#cc-property-logo-file-name'),
    propPatternRotate:$('#cc-property-pattern-rotate'),propAccessories:$('#cc-property-accessories'),propPayload:$('#cc-property-payload'),
    addBtn:$('#add2cart'),baseNoPaint:$('#cc-base-no-paint'),logoNoPaint:$('#cc-logo-no-paint'),accessoryNone:$('#cc-accessory-none')
  };

  function money(cents){return (Number(cents||0)/100).toLocaleString('en-US',{style:'currency',currency:'USD'});}
  function normalizeHex(value){value=String(value||'#000000').trim();if(value.charAt(0)!=='#') value='#'+value;return value.toLowerCase();}
  function hexToRgb(hex){hex=normalizeHex(hex).replace('#','');if(hex.length===3) hex=hex.split('').map(x=>x+x).join('');const n=parseInt(hex,16);return [(n>>16)&255,(n>>8)&255,n&255];}
  function sameColor(a,b){return normalizeHex(a)===normalizeHex(b);}
  function setText(node,value){if(node) node.textContent=value;}
  function setStatus(message,isError){if(!el.status) return;el.status.textContent=message||'';el.status.classList.toggle('is-error',!!isError);el.status.classList.toggle('is-success',!!message&&!isError);}
  function keyFromPattern(value){return String(value||'none').toLowerCase().replace(/\s+/g,'');}
  function noneFor(id){const input=$(`.cc-color-none-input[data-none-for="${id}"]`);return !!(input&&input.checked);}
  function displayColor(color,isNone){return isNone?'None':color;}

  function loadImage(src){
    return new Promise((resolve,reject)=>{
      const img=new Image();
      img.crossOrigin='anonymous';
      img.onload=()=>resolve(img);
      img.onerror=reject;
      img.src=src;
    });
  }

  async function loadProduct(){
    try{
      setStatus('Loading coin quantities...');
      if(el.addBtn) el.addBtn.disabled=true;

      const res=await fetch(`/products/${productHandle}.js`,{headers:{Accept:'application/json'}});
      if(!res.ok) throw new Error(`Could not load product handle: ${productHandle}`);
      const product=await res.json();

      store._product=product;store._base=null;store._quantities=[];
      Object.keys(store).forEach(k=>{if(k!=='_base'&&k!=='_quantities'&&k!=='_product') delete store[k];});

      product.variants.forEach((variant,idx)=>{
        const qty=getQtyFromVariant(variant,product);
        if(idx===0) store._base={id:variant.id};
        if(!qty) return;
        store[qty]={id:variant.id,title:variant.title,option1:variant.option1,option2:variant.option2,option3:variant.option3,price:variant.price,compare_at_price:variant.compare_at_price||null,available:variant.available!==false};
      });

      store._quantities=Object.keys(store).filter(k=>k!=='_base'&&k!=='_quantities'&&k!=='_product').map(k=>parseInt(k,10)).filter(Boolean).sort((a,b)=>a-b);
      if(!store._quantities.length) throw new Error('No quantity variants found. Check product handle and variant option values.');

      initQuantitySlider();
      updateStateFromForm();
      setStatus('');
      if(el.addBtn) el.addBtn.disabled=false;
    }catch(err){
      console.error(err);
      setStatus(err.message||'Could not load custom coin quantities.',true);
      if(el.addBtn) el.addBtn.disabled=true;
    }
  }

  function getQtyFromVariant(variant,product){
    const optionNames=(product&&product.options?product.options:[]).map(o=>typeof o==='string'?o.toLowerCase():String(o.name||'').toLowerCase());
    const optionValues=[variant.option1,variant.option2,variant.option3];

    for(let i=0;i<optionValues.length;i++){
      const name=optionNames[i]||'',value=optionValues[i];
      if(!value) continue;
      if(name.includes('qty')||name.includes('quantity')||name.includes('coin')){
        const qty=parseQty(value);
        if(qty) return qty;
      }
    }

    for(const value of optionValues){
      const qty=parseQty(value);
      if(qty) return qty;
    }

    return parseQty(variant.title);
  }

  function parseQty(value){
    if(value==null) return null;
    const text=String(value).replace(/,/g,'').trim();
    const match=text.match(/(?:^|\D)(\d{2,5})(?:\D|$)/);
    if(!match) return null;
    const qty=parseInt(match[1],10);
    return qty>0?qty:null;
  }


  function getDealInfo(qty,variant){
    if(!variant) return null;

    let regular=Number(variant.compare_at_price||0);

    if(!regular&&store._quantities.length){
      const firstQty=store._quantities[0];
      const first=store[firstQty];

      if(first&&first.price&&qty>firstQty){
        regular=Math.round((first.price/firstQty)*qty);
      }
    }

    if(!regular||regular<=variant.price){
      return {regular:null,discount:0};
    }

    const discount=Math.round((1-(variant.price/regular))*100);

    return {regular,discount};
  }

  function getMilestoneBadges(){
    const quantities=store._quantities||[];
    if(!quantities.length) return [];

    const maxQty=Math.max(...quantities);
    const results=[];

    if(quantities.includes(100)){
      results.push({qty:100,text:'MOST POPULAR',className:'is-popular'});
    }

    if(quantities.includes(500)){
      results.push({qty:500,text:'BEST VALUE',className:'is-best'});
    }

    if(maxQty!==100&&maxQty!==500){
      results.push({qty:maxQty,text:'SAVE BIG',className:'is-biggest'});
    }

    return results;
  }

  function renderQuantityMilestones(){
    if(!el.qtyMilestones||!store._quantities.length) return;

    const quantities=store._quantities;
    const count=quantities.length;

    el.qtyMilestones.innerHTML=getMilestoneBadges().map(item=>{
      const index=quantities.indexOf(item.qty);
      if(index<0) return '';

      const left=count<=1?0:(index/(count-1))*100;
      const variant=store[item.qty];
      const deal=getDealInfo(item.qty,variant);
      const discount=deal&&deal.discount
        ?`<small>${deal.discount}% OFF</small>`
        :'';

      return `<button
        type="button"
        class="cc-qty-milestone ${item.className}"
        data-qty-index="${index}"
        style="left:${left}%"
        aria-label="${item.qty} coins ${item.text}"
      >
        <span>${item.text.split(' ').map(word=>`<i>${word}</i>`).join('')}</span>
        ${discount}
      </button>`;
    }).join('');

    $$('.cc-qty-milestone').forEach(btn=>btn.addEventListener('click',()=>{
      if(!el.qty) return;

      el.qty.value=btn.dataset.qtyIndex;

      updateQuantity();
    }));
  }

  function syncQuantityMilestoneSelection(){
    if(!el.qtyMilestones||!el.qty) return;

    const idx=parseInt(el.qty.value,10)||0;

    $$('.cc-qty-milestone').forEach(btn=>{
      btn.classList.toggle(
        'is-selected',
        parseInt(btn.dataset.qtyIndex,10)===idx
      );
    });
  }

  function initQuantitySlider(){
    const quantities=store._quantities;
    if(!el.qty||!quantities.length) return;

    el.qty.min=0;el.qty.max=quantities.length-1;el.qty.step=1;el.qty.value=0;
    if(el.qtyDatalist) el.qtyDatalist.innerHTML=quantities.map((qty,i)=>`<option value="${i}" label="${qty.toLocaleString()}"></option>`).join('');

    el.qty.addEventListener('input',updateQuantity);
    el.qty.addEventListener('change',updateQuantity);
    renderQuantityMilestones();
    updateQuantity();
  }

  function updateQuantity(){
    const quantities=store._quantities;
    if(!el.qty||!quantities.length) return;

    const idx=Math.max(0,Math.min(quantities.length-1,parseInt(el.qty.value,10)||0));
    const qty=quantities[idx],variant=store[qty];

    state.quantity=qty;state.variant=variant||null;
    const qtyText=`${qty.toLocaleString()} coins`,priceText=variant?money(variant.price):'Unavailable';
    const deal=getDealInfo(qty,variant);

    setText(el.qtyLabel,qtyText);setText(el.summaryQty,qtyText);setText(el.mobileQty,qtyText);
    setText(el.price,priceText);setText(el.mobilePrice,priceText);setText(el.cartPrice,priceText);

    if(el.panelPrice){
      if(variant&&deal&&deal.regular&&deal.discount){
        el.panelPrice.innerHTML=`<del>${money(deal.regular)}</del> <span class="cc-sale-price">${money(variant.price)}</span> <em>${deal.discount}% OFF</em>`;
      }else{
        el.panelPrice.textContent=priceText;
      }
    }

    syncQuantityMilestoneSelection();
    updatePayloadFields();
  }

  function updateStateFromForm(){
    const metal=$('input[name="metal"]:checked');
    const pattern=$('input[name="pattern"]:checked');
    const bgTone=$('input[name="backgroundToneCount"]:checked');
    const logoColorCount=$('input[name="logoColorCount"]:checked');

    if(metal){state.metal=metal.value;state.metalColor=metal.dataset.color||'#b19e69';}
    if(pattern){state.pattern=pattern.value;state.patternKey=keyFromPattern(pattern.value);}
    enforcePatternColorLimit();
    if(bgTone) state.backgroundToneCount=parseInt(bgTone.value,10)||1;
    if(logoColorCount) state.logoColorCount=parseInt(logoColorCount.value,10)||1;

    state.baseNoPaint=!!(el.baseNoPaint&&el.baseNoPaint.checked);
    state.logoNoPaint=!!(el.logoNoPaint&&el.logoNoPaint.checked);

    state.tone1=normalizeHex($('#cc-pattern-color-1')&&$('#cc-pattern-color-1').value);
    state.tone2=normalizeHex($('#cc-pattern-color-2')&&$('#cc-pattern-color-2').value);
    state.tone3=normalizeHex($('#cc-pattern-color-3')&&$('#cc-pattern-color-3').value);

    const toneNone1=noneFor('cc-pattern-color-1');
    const toneNone2=noneFor('cc-pattern-color-2');
    const toneNone3=noneFor('cc-pattern-color-3');

    if(state.backgroundToneCount===1){
      state.rgbColors=[state.tone1,state.tone1,state.tone1];
      state.rgbNone=[toneNone1,toneNone1,toneNone1];
    }else if(state.backgroundToneCount===2){
      state.rgbColors=[state.tone1,state.tone1,state.tone2];
      state.rgbNone=[toneNone1,toneNone2,toneNone1];
    }else{
      state.rgbColors=[state.tone1,state.tone2,state.tone3];
      state.rgbNone=[toneNone1,toneNone2,toneNone3];
    }

    state.toneNone=[toneNone1,toneNone2,toneNone3];

    state.logoColors=[
      normalizeHex($('#cc-logo-color-1')&&$('#cc-logo-color-1').value),
      normalizeHex($('#cc-logo-color-2')&&$('#cc-logo-color-2').value)
    ];
    state.logoNone=[noneFor('cc-logo-color-1'),noneFor('cc-logo-color-2')];

    state.logoScale=parseInt(el.logoScale&&el.logoScale.value,10)||100;
    state.logoThreshold=parseInt(el.logoThreshold&&el.logoThreshold.value,10);
    if(Number.isNaN(state.logoThreshold)) state.logoThreshold=125;

    state.patternRotate=parseInt(el.patternRotate&&el.patternRotate.value,10)||0;
    state.accessories=getSelectedAccessories();

    updateColorVisibility();
    updatePreview();
    updateSummaries();
    updatePayloadFields();
  }

  function getSelectedAccessories(){
    const picked=$$('input[name="accessories"]:checked').map(input=>input.value);
    if(!picked.length) return ['None'];
    if(picked.includes('None')) return ['None'];
    return picked;
  }

  function updateColorVisibility(){
    $('#ccPatternColorGrid')?.classList.toggle('is-disabled',state.baseNoPaint);
    $('#ccLogoColorGrid')?.classList.toggle('is-disabled',state.logoNoPaint);

    $$('[data-pattern-color-slot]').forEach(control=>{
      const slot=parseInt(control.dataset.patternColorSlot,10)||1;
      control.classList.toggle('is-hidden',slot>state.backgroundToneCount);
    });

    $$('[data-logo-color-slot]').forEach(control=>{
      const slot=parseInt(control.dataset.logoColorSlot,10)||1;
      control.classList.toggle('is-hidden',slot>state.logoColorCount);
    });

    const twoColorLogo=state.logoColorCount===2;
    if(el.logoThresholdWrap) el.logoThresholdWrap.classList.toggle('is-disabled',!twoColorLogo);
    if(el.logoThreshold) el.logoThreshold.disabled=!twoColorLogo;

    const label1=$('label[for="cc-pattern-color-1"]');
    const label2=$('label[for="cc-pattern-color-2"]');
    const label3=$('label[for="cc-pattern-color-3"]');

    // if(label1) label1.textContent=state.backgroundToneCount===1?'All RGB Channels':'Red + Green';
    // if(label2) label2.textContent=state.backgroundToneCount===2?'Blue Channel':'Green Channel';
    // if(label3) label3.textContent='Blue Channel';
    if(label1) label1.textContent='Color 1';
    if(label2) label2.textContent='Color 2';
    if(label3) label3.textContent='Color 3';

    $$('.cc-color-none-input').forEach(input=>{
      const target=$(`#${input.dataset.noneFor}`);
      input.closest('.cc-color-control')?.classList.toggle('is-none-selected',input.checked);
      if(target) target.disabled=input.checked;
    });
  }

  function updatePreview(){
    root.dataset.pattern=state.pattern;
    root.dataset.patternKey=state.patternKey;
    root.dataset.baseNoPaint=state.baseNoPaint?'true':'false';
    root.dataset.logoNoPaint=state.logoNoPaint?'true':'false';

    if(el.preview){
      el.preview.style.setProperty('--coin-metal',state.metalColor);
      el.preview.style.setProperty('--bg-red',state.rgbNone[0]?'#000000':state.rgbColors[0]);
      el.preview.style.setProperty('--bg-green',state.rgbNone[1]?'#000000':state.rgbColors[1]);
      el.preview.style.setProperty('--bg-blue',state.rgbNone[2]?'#000000':state.rgbColors[2]);
      el.preview.style.setProperty('--logo-color-1',state.logoNoPaint||state.logoNone[0]?state.metalColor:state.logoColors[0]);
      el.preview.style.setProperty('--logo-color-2',state.logoNoPaint||state.logoNone[1]?state.metalColor:(state.logoColors[1]||state.logoColors[0]));
      el.preview.style.setProperty('--logo-scale',state.logoScale/100);
      el.preview.style.setProperty('--pattern-rotate',`${state.patternRotate}deg`);
    }

    setText(el.logoScaleLabel,`${state.logoScale}%`);
    setText(el.logoThresholdLabel,String(state.logoThreshold));
    setText(el.patternRotateLabel,String(state.patternRotate));

    loadPatternImages();
    updateLogoCanvas();
  }

  async function loadPatternImages(){
    const urls=PATTERNS[state.patternKey]||PATTERNS.none;

    try{
      if(!state.backgroundImage||state.backgroundImage.dataset.src!==urls.pattern){
        state.backgroundImage=await loadImage(urls.pattern);
        state.backgroundImage.dataset.src=urls.pattern;
      }

      if(!state.backgroundOverlay||state.backgroundOverlay.dataset.src!==urls.overlay){
        state.backgroundOverlay=await loadImage(urls.overlay);
        state.backgroundOverlay.dataset.src=urls.overlay;
      }

      updateBackgroundCanvas();
      updateOverlayImage();
    }catch(e){
      console.warn('Pattern image failed:',e);
      updateBackgroundCanvas();
    }
  }

  function updateBackgroundCanvas(){
    const canvas=el.bgCanvas;
    if(!canvas) return;

    const ctx=canvas.getContext('2d',{willReadFrequently:true});
    const size=900;
    canvas.width=size;canvas.height=size;
    ctx.clearRect(0,0,size,size);

    if(state.baseNoPaint||!state.backgroundImage||state.patternKey==='none'){
      // ctx.fillStyle=state.baseNoPaint?state.metalColor:(state.rgbNone[0]?state.metalColor:state.rgbColors[0]);
      ctx.fillStyle=state.baseNoPaint
        ?state.metalColor
        :(state.rgbNone[0]?state.metalColor:state.rgbColors[0]);
      ctx.fillRect(0,0,size,size);
      canvas.classList.add('has-image');
      return;
    }

    const img=state.backgroundImage;
    const scale=Math.max(size/img.width,size/img.height);
    const w=img.width*scale,h=img.height*scale;

    ctx.drawImage(img,(size-w)/2,(size-h)/2,w,h);

    const imageData=ctx.getImageData(0,0,size,size);
    const data=imageData.data;
    // const paints=[
    //   state.rgbNone[0]?null:hexToRgb(state.rgbColors[0]),
    //   state.rgbNone[1]?null:hexToRgb(state.rgbColors[1]),
    //   state.rgbNone[2]?null:hexToRgb(state.rgbColors[2])
    // ];
    const metalPaint=hexToRgb(state.metalColor);

    const paints=[
      state.rgbNone[0]?metalPaint:hexToRgb(state.rgbColors[0]),
      state.rgbNone[1]?metalPaint:hexToRgb(state.rgbColors[1]),
      state.rgbNone[2]?metalPaint:hexToRgb(state.rgbColors[2])
    ];

    const active=paints.filter(Boolean);
    const allActiveSame=active.length>0&&active.every(p=>p[0]===active[0][0]&&p[1]===active[0][1]&&p[2]===active[0][2]);

    for(let i=0;i<data.length;i+=4){
      const a=data[i+3];
      if(a<8) continue;

      if(allActiveSame){
        data[i]=active[0][0];data[i+1]=active[0][1];data[i+2]=active[0][2];
        continue;
      }

      const r=data[i],g=data[i+1],b=data[i+2];
      let idx=0,max=r;
      if(g>max){idx=1;max=g;}
      if(b>max){idx=2;max=b;}

      if(max<8){
        data[i]=state.metalColor?hexToRgb(state.metalColor)[0]:0;
        data[i+1]=state.metalColor?hexToRgb(state.metalColor)[1]:0;
        data[i+2]=state.metalColor?hexToRgb(state.metalColor)[2]:0;
        continue;
      }

      const chosen=paints[idx];

      data[i]=chosen[0];
      data[i+1]=chosen[1];
      data[i+2]=chosen[2];
      // if(!chosen){
      //   data[i+3]=0;
      //   continue;
      // }

      data[i]=chosen[0];data[i+1]=chosen[1];data[i+2]=chosen[2];
    }

    ctx.putImageData(imageData,0,0);
    canvas.classList.add('has-image');
  }

  function updateOverlayImagexxx(){
    if(!el.bgOverlay) return;
    const urls=PATTERNS[state.patternKey]||PATTERNS.none;
    el.bgOverlay.style.backgroundImage=state.patternKey==='none'?'none':`url("${urls.overlay}")`;
  }
async function updateOverlayImage(){
  if(!el.bgOverlay) return;

  if(state.patternKey==='none'||!state.backgroundOverlay){
    el.bgOverlay.style.backgroundImage='none';
    return;
  }

  const img=state.backgroundOverlay;
  const size=900;

  const canvas=document.createElement('canvas');
  canvas.width=size;
  canvas.height=size;

  const ctx=canvas.getContext('2d');

  const scale=Math.max(
    size/img.width,
    size/img.height
  );

  const w=img.width*scale;
  const h=img.height*scale;

  ctx.drawImage(
    img,
    (size-w)/2,
    (size-h)/2,
    w,
    h
  );

  const imageData=ctx.getImageData(0,0,size,size);
  const data=imageData.data;

  const metal=hexToRgb(state.metalColor);

  for(let i=0;i<data.length;i+=4){
    if(data[i+3]<8) continue;

    data[i]=metal[0];
    data[i+1]=metal[1];
    data[i+2]=metal[2];
  }

  ctx.putImageData(imageData,0,0);

  el.bgOverlay.style.backgroundImage=
    `url("${canvas.toDataURL('image/png')}")`;
}

  function updateLogoCanvas(){
    if(!el.logoCanvas) return;

    const canvas=el.logoCanvas;
    const ctx=canvas.getContext('2d',{willReadFrequently:true});

    if(!state.logoImage){
      loadDefaultLogo();
      return;
    }

    const img=state.logoImage;
    const size=512;
    canvas.width=size;
    canvas.height=size;
    ctx.clearRect(0,0,size,size);

    const ratio=Math.min(size/img.width,size/img.height);
    const w=Math.max(1,Math.round(img.width*ratio));
    const h=Math.max(1,Math.round(img.height*ratio));
    const x=Math.round((size-w)/2);
    const y=Math.round((size-h)/2);

    ctx.drawImage(img,x,y,w,h);

    if(!state.logoNoPaint){
      const imageData=ctx.getImageData(0,0,size,size);
      const data=imageData.data;

      const metal=hexToRgb(state.metalColor);
      const color1=state.logoNone[0]?metal:hexToRgb(state.logoColors[0]);
      const color2=state.logoNone[1]?metal:hexToRgb(state.logoColors[1]);
      const twoColor=state.logoColorCount===2;
      const threshold=Number(state.logoThreshold);

      for(let i=0;i<data.length;i+=4){
        if(data[i+3]===0) continue;

        let chosen=color1;

        if(twoColor){
          const y=(0.2126*data[i])+(0.7152*data[i+1])+(0.0722*data[i+2]);
          chosen=y>=threshold?color1:color2;
        }

        data[i]=chosen[0];
        data[i+1]=chosen[1];
        data[i+2]=chosen[2];
        data[i+3]=255;
      }

      ctx.putImageData(imageData,0,0);
    }

    canvas.classList.add('has-image');
    if(el.logoFallback) el.logoFallback.style.display='none';
  }

  async function loadDefaultLogo(){
    if(state.__loadingDefaultLogo) return;
    state.__loadingDefaultLogo=true;

    try{
      state.logoImage=await loadImage(DEFAULT_LOGO);
      state.logoFileName='BOD Crown Logo';
      setText(el.logoFileName,'BOD Crown Logo');
      state.__loadingDefaultLogo=false;
      updateLogoCanvas();
      updatePayloadFields();
    }catch(e){
      state.__loadingDefaultLogo=false;
      console.warn('Default logo failed:',e);
      if(el.logoFallback) el.logoFallback.style.display='';
    }
  }

  function updateSummaries(){
    const patternLabel=state.pattern==='None'?'No pattern':`${state.pattern} pattern`;
    setText(el.summaryMetal,`${state.metal} metal`);
    setText(el.summaryPattern,patternLabel);
    setText(el.cartMetal,state.metal);
    setText(el.cartPattern,state.pattern);
    setText(el.cartLogoScale,`${state.logoScale}%`);
  }

  function bgText(){
    if(state.baseNoPaint) return 'None';
    if(state.backgroundToneCount===1) return `1 Tone: ${displayColor(state.tone1,state.toneNone[0])} -> R/G/B`;
    if(state.backgroundToneCount===2) return `2 Tone: ${displayColor(state.tone1,state.toneNone[0])} -> R/G, ${displayColor(state.tone2,state.toneNone[1])} -> B`;
    return `3 Tone: R:${displayColor(state.tone1,state.toneNone[0])} | G:${displayColor(state.tone2,state.toneNone[1])} | B:${displayColor(state.tone3,state.toneNone[2])}`;
  }

  function logoText(){
    if(state.logoNoPaint) return 'None';
    const vals=[displayColor(state.logoColors[0],state.logoNone[0])];
    if(state.logoColorCount>1) vals.push(displayColor(state.logoColors[1],state.logoNone[1]));
    return vals.join(' | ');
  }

  function buildPayload(){
    return {
      product:state.product,
      diameter:state.diameter,
      thickness:state.thickness,
      material:state.metal,
      baseMetal:{name:state.metal,color:state.metalColor,appliesTo:['outline','rim','back']},
      background:{
        pattern:state.pattern,patternKey:state.patternKey,rotate:state.patternRotate,
        paint:state.baseNoPaint?'None':'Painted',toneCount:state.baseNoPaint?0:state.backgroundToneCount,
        tone1:state.baseNoPaint||state.toneNone[0]?null:state.tone1,
        tone2:state.baseNoPaint||state.backgroundToneCount<2||state.toneNone[1]?null:state.tone2,
        tone3:state.baseNoPaint||state.backgroundToneCount<3||state.toneNone[2]?null:state.tone3,
        redChannel:state.baseNoPaint||state.rgbNone[0]?null:state.rgbColors[0],
        greenChannel:state.baseNoPaint||state.rgbNone[1]?null:state.rgbColors[1],
        blueChannel:state.baseNoPaint||state.rgbNone[2]?null:state.rgbColors[2]
      },
      logo:{
        fileName:state.logoFileName||null,paint:state.logoNoPaint?'None':'Painted',
        scale:state.logoScale,threshold:state.logoThreshold,colorCount:state.logoNoPaint?0:state.logoColorCount,
        colorA:state.logoNoPaint||state.logoNone[0]?null:state.logoColors[0],
        colorB:state.logoNoPaint||state.logoColorCount<2||state.logoNone[1]?null:state.logoColors[1]
      },
      accessories:state.accessories,
      quantity:state.quantity,
      variantId:state.variant?state.variant.id:null
    };
  }

  function updatePayloadFields(){
    const payload=buildPayload();

    if(el.propMetal) el.propMetal.value=state.metal;
    if(el.propPattern) el.propPattern.value=state.pattern;
    if(el.propBasePaint) el.propBasePaint.value=bgText();
    if(el.propPatternColorCount) el.propPatternColorCount.value=state.baseNoPaint?'0':String(state.backgroundToneCount);
    if(el.propPatternColors) el.propPatternColors.value=bgText();
    if(el.propLogoPaint) el.propLogoPaint.value=logoText();
    if(el.propLogoColorCount) el.propLogoColorCount.value=state.logoNoPaint?'0':String(state.logoColorCount);
    if(el.propLogoColors) el.propLogoColors.value=logoText();
    if(el.propLogoScale) el.propLogoScale.value=`${state.logoScale}%`;
    if(el.propLogoThreshold) el.propLogoThreshold.value=String(state.logoThreshold);
    if(el.propLogoFileName) el.propLogoFileName.value=state.logoFileName||'';
    if(el.propPatternRotate) el.propPatternRotate.value=String(state.patternRotate);
    if(el.propAccessories) el.propAccessories.value=state.accessories.join(' | ');
    if(el.propPayload) el.propPayload.value=JSON.stringify(payload);

    window.orderData=payload;
  }


  function dataURLtoBlob(dataUrl){
    const parts=dataUrl.split(','),meta=parts[0],data=parts[1];
    const mime=(meta.match(/:(.*?);/)||[])[1]||'image/png';
    const bin=atob(data);
    const arr=new Uint8Array(bin.length);
    for(let i=0;i<bin.length;i++) arr[i]=bin.charCodeAt(i);
    return new Blob([arr],{type:mime});
  }

  function canvasToBlob(canvas,type='image/png',quality){
    return new Promise(resolve=>canvas.toBlob(resolve,type,quality));
  }

  async function renderCartPreviewBlob(){
    const size=1200;
    const outerR=540;
    const innerR=430;
    const center=size/2;

    /* Force the exact current UI state to finish rendering before capture. */
    updateStateFromForm();
    await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));

    const canvas=document.createElement('canvas');
    canvas.width=size;
    canvas.height=size;
    const ctx=canvas.getContext('2d');
    ctx.clearRect(0,0,size,size);

    /* Metal body */
    ctx.save();
    ctx.beginPath();
    ctx.arc(center,center,outerR,0,Math.PI*2);
    ctx.closePath();
    const metalGrad=ctx.createRadialGradient(center-(outerR*.28),center-(outerR*.32),outerR*.15,center,center,outerR);
    metalGrad.addColorStop(0,'#ffffff');
    metalGrad.addColorStop(.08,state.metalColor);
    metalGrad.addColorStop(.55,state.metalColor);
    metalGrad.addColorStop(1,'#2a2a2a');
    ctx.fillStyle=metalGrad;
    ctx.fill();
    ctx.restore();

    /* Pattern face: background AND overlay rotate as one group, matching .cc-pattern-spin. */
    ctx.save();
    ctx.beginPath();
    ctx.arc(center,center,innerR,0,Math.PI*2);
    ctx.closePath();
    ctx.clip();

    ctx.translate(center,center);
    ctx.rotate((state.patternRotate||0)*Math.PI/180);

    if(el.bgCanvas){
      ctx.drawImage(el.bgCanvas,-innerR,-innerR,innerR*2,innerR*2);
    }else{
      ctx.fillStyle=state.baseNoPaint?state.metalColor:state.rgbColors[0];
      ctx.fillRect(-innerR,-innerR,innerR*2,innerR*2);
    }

    if(state.patternKey!=='none'&&!state.baseNoPaint&&state.backgroundOverlay){
      const overlayCanvas=document.createElement('canvas');
      overlayCanvas.width=900;
      overlayCanvas.height=900;
      const octx=overlayCanvas.getContext('2d');
      const img=state.backgroundOverlay;
      const scale=Math.max(900/img.width,900/img.height);
      const w=img.width*scale,h=img.height*scale;
      octx.drawImage(img,(900-w)/2,(900-h)/2,w,h);
      octx.globalCompositeOperation='source-in';
      octx.fillStyle=state.metalColor;
      octx.fillRect(0,0,900,900);
      octx.globalCompositeOperation='source-over';
      ctx.globalAlpha=1;
      ctx.drawImage(overlayCanvas,-innerR,-innerR,innerR*2,innerR*2);
      ctx.globalAlpha=1;
    }
    ctx.restore();

    /* Rim/detail */
    ctx.save();
    ctx.beginPath();ctx.arc(center,center,innerR,0,Math.PI*2);ctx.strokeStyle='rgba(255,255,255,.25)';ctx.lineWidth=8;ctx.stroke();
    ctx.beginPath();ctx.arc(center,center,outerR-26,0,Math.PI*2);ctx.strokeStyle='rgba(0,0,0,.25)';ctx.lineWidth=22;ctx.stroke();
    ctx.beginPath();ctx.arc(center,center,outerR-64,0,Math.PI*2);ctx.strokeStyle='rgba(255,255,255,.18)';ctx.lineWidth=7;ctx.stroke();
    ctx.restore();

    /* Logo uses the already-processed current logo canvas and current scale. */
    if(el.logoCanvas){
      const logoSize=Math.round(innerR*1.18*(state.logoScale/100));
      ctx.drawImage(el.logoCanvas,center-logoSize/2,center-logoSize/2,logoSize,logoSize);
    }

    return canvasToBlob(canvas,'image/png');
  }

  async function addToCartWithPreview(){
    if(!state.variant||!state.variant.id) throw new Error('No quantity variant selected.');
    updatePayloadFields();

    const form=document.createElement('form');
    form.method='POST';
    form.action='/cart/add';
    form.enctype='multipart/form-data';
    form.style.display='none';

    function addHidden(name,value){
      const input=document.createElement('input');
      input.type='hidden';
      input.name=name;
      input.value=value;
      form.appendChild(input);
    }

    function addFile(name,file){
      const input=document.createElement('input');
      input.type='file';
      input.name=name;
      const dt=new DataTransfer();
      dt.items.add(file);
      input.files=dt.files;
      form.appendChild(input);
    }

    addHidden('id',String(state.variant.id));
    addHidden('quantity','1');
    addHidden('properties[Base Metal]',state.metal);
    addHidden('properties[Pattern]',state.pattern);
    addHidden('properties[Background Paint]',bgText());
    addHidden('properties[Background RGB Channel Colors]',bgText());
    addHidden('properties[Pattern Rotate]',String(state.patternRotate));
    addHidden('properties[Logo Paint]',logoText());
    addHidden('properties[Logo Color Count]',state.logoNoPaint?'0':String(state.logoColorCount));
    addHidden('properties[Logo Colors]',logoText());
    addHidden('properties[Logo Scale]',`${state.logoScale}%`);
    addHidden('properties[Logo Tone Threshold]',String(state.logoThreshold));
    addHidden('properties[Logo File Name]',state.logoFileName||'');
    addHidden('properties[Accessories]',state.accessories.join(' | '));
    addHidden('properties[_coin_payload]',JSON.stringify(buildPayload()));

    const previewBlob=await renderCartPreviewBlob();
    if(previewBlob){
      const previewFile=new File([previewBlob],`custom-coin-preview-${Date.now()}.png`,{type:'image/png'});
      addFile('properties[Screenshot 1]',previewFile);
      addFile('properties[Custom Design]',previewFile);
    }

    const logoFile=el.logoUpload&&el.logoUpload.files&&el.logoUpload.files[0];
    if(logoFile) addFile('properties[Logo Upload]',logoFile);

    document.body.appendChild(form);
    form.submit();
  }


  function addToCart(){
    return addToCartWithPreview();
  }

  function bindTabs(){
    const tabs=$$('#fxTabsDesktop .fx-tab');
    const sections=$$('.cc-section');

    function show(target,tab){
      sections.forEach(sec=>sec.classList.toggle('is-active','#'+sec.id===target));
      tabs.forEach(t=>{
        const active=t===tab;
        t.classList.toggle('active',active);
        t.classList.toggle('bf-menu-selected',active);
        t.setAttribute('aria-selected',String(active));
      });
    }

    tabs.forEach(tab=>tab.addEventListener('click',()=>show(tab.dataset.target,tab)));
  }

  function bindLogoUpload(){
    if(!el.logoUpload) return;

    el.logoUpload.addEventListener('change',()=>{
      const file=el.logoUpload.files&&el.logoUpload.files[0];

      if(!file){
        state.logoFileName='BOD Crown Logo';
        state.logoImage=null;
        setText(el.logoFileName,'BOD Crown Logo');
        updateStateFromForm();
        return;
      }

      state.logoFileName=file.name;
      setText(el.logoFileName,file.name);

      const url=URL.createObjectURL(file);
      const img=new Image();

      img.onload=()=>{
        img.dataset.objectUrl=url;
        state.logoImage=img;
        updateStateFromForm();
      };

      img.onerror=()=>{
        URL.revokeObjectURL(url);
        setStatus('Could not read that image file.',true);
      };

      img.src=url;
    });
  }

  function bindAccessories(){
    $$('input[name="accessories"]').forEach(input=>input.addEventListener('change',e=>{
      if(e.target.value==='None'&&e.target.checked) $$('input[name="accessories"]').forEach(other=>{if(other!==e.target) other.checked=false;});
      else if(e.target.checked&&el.accessoryNone) el.accessoryNone.checked=false;
      if(!$$('input[name="accessories"]:checked').length&&el.accessoryNone) el.accessoryNone.checked=true;
      updateStateFromForm();
    }));
  }

  function bindEvents(){
    $$('input[name="metal"], input[name="pattern"], input[name="backgroundToneCount"], input[name="logoColorCount"], input[type="color"], .cc-color-none-input, #cc-logo-scale, #cc-logo-threshold, #patternRotate, #cc-base-no-paint, #cc-logo-no-paint').forEach(input=>{
      input.addEventListener('change',updateStateFromForm);
      input.addEventListener('input',updateStateFromForm);
    });

    const randomizeBtn=$('#ccRandomize');

if(randomizeBtn){
  randomizeBtn.addEventListener('click',randomizeCoin);
}

    if(el.form) el.form.addEventListener('submit',async e=>{
      e.preventDefault();
      if(el.addBtn) el.addBtn.disabled=true;
      setStatus('Adding custom coins...');

      try{
        await addToCart();
        setStatus('Added to cart.');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      }catch(err){
        console.error(err);
        setStatus(err.message||'Could not add custom coins.',true);
      }finally{
        if(el.addBtn&&state.variant) el.addBtn.disabled=false;
      }
    });
  }

function enforcePatternColorLimit(){
  const pattern=PATTERNS[state.patternKey]||PATTERNS.none;
  const maxColors=pattern.maxColors||3;

  const radios=$$('input[name="backgroundToneCount"]');

  radios.forEach(input=>{
    const count=parseInt(input.value,10);
    input.disabled=count>maxColors;

    const label=root.querySelector(`label[for="${input.id}"]`);
    if(label) label.classList.toggle('is-disabled',count>maxColors);
  });

  if(state.backgroundToneCount>maxColors){
    state.backgroundToneCount=maxColors;

    const allowed=$(`input[name="backgroundToneCount"][value="${maxColors}"]`);
    if(allowed) allowed.checked=true;
  }
}

/* Randomizer */
function randomItem(arr){
  return arr[Math.floor(Math.random()*arr.length)];
}
const RANDOM_COLORS=[
  '#ff0000',
  '#ff6600',
  '#ffcc00',
  '#ffff00',
  '#66cc00',
  '#00aa44',
  '#00cccc',
  '#0099ff',
  '#0055cc',
  '#6633cc',
  '#9900cc',
  '#cc0088',
  '#ff66aa',
  '#ffffff',
  '#cccccc',
  '#666666',
  '#111111',
  '#8b4513',
  '#d4af37',
  '#b87333'
];

function randomHex(){
  return randomItem(RANDOM_COLORS);
}
function randomHexXXX(){
  const h=Math.floor(Math.random()*0x1000000).toString(16).padStart(6,'0');
  return `#${h}`;
}

function weightedToneCount(){
  const roll=Math.random();

  if(roll<0.80) return 3;
  if(roll<0.97) return 2;

  return 1;
}

function setColorInput(id,color){
  const input=$(`#${id}`);
  if(input) input.value=color;

  const noneToggle=$(`.cc-color-none-input[data-none-for="${id}"]`);
  if(noneToggle) noneToggle.checked=false;
}

function randomizeCoin(){
  const currentLogoColorCount=state.logoColorCount;

  /* METAL */
  const metalInputs=$$('input[name="metal"]');
  const randomMetal=randomItem(metalInputs);

  if(randomMetal){
    randomMetal.checked=true;
  }


  /* PATTERN */
  const patternInputs=$$('input[name="pattern"]');
  const randomPattern=randomItem(patternInputs);

  if(randomPattern){
    randomPattern.checked=true;
  }


  /* GET PATTERN COLOR LIMIT */
  const patternKey=randomPattern
    ?keyFromPattern(randomPattern.value)
    :state.patternKey;

  const patternData=PATTERNS[patternKey]||PATTERNS.none;
  const maxColors=patternData.maxColors||3;


  /* WEIGHTED TONE COUNT */
  let toneCount=weightedToneCount();

  if(toneCount>maxColors){
    toneCount=maxColors;
  }

  const toneRadio=$(
    `input[name="backgroundToneCount"][value="${toneCount}"]`
  );

  if(toneRadio){
    toneRadio.checked=true;
  }


  /* BACKGROUND COLORS */
  setColorInput('cc-pattern-color-1',randomHex());
  setColorInput('cc-pattern-color-2',randomHex());
  setColorInput('cc-pattern-color-3',randomHex());


  /* KEEP CURRENT LOGO COLOR COUNT */
  const logoCountRadio=$(
    `input[name="logoColorCount"][value="${currentLogoColorCount}"]`
  );

  if(logoCountRadio){
    logoCountRadio.checked=true;
  }


  /* LOGO COLORS */
  setColorInput('cc-logo-color-1',randomHex());

  if(currentLogoColorCount===2){
    setColorInput('cc-logo-color-2',randomHex());
  }


  /* TURN FULL NO-PAINT MODES OFF */
  if(el.baseNoPaint){
    el.baseNoPaint.checked=false;
  }

  if(el.logoNoPaint){
    el.logoNoPaint.checked=false;
  }


  /* APPLY EVERYTHING */
  updateStateFromForm();
}
  bindTabs();
  bindLogoUpload();
  bindAccessories();
  bindEvents();
  loadDefaultLogo();
  loadProduct();
})();


/* === v14.2 four-step navigation layer === */
(function(){
  const root=document.getElementById('custom-coin-tool');
  if(!root) return;
  const qs=(s,c=root)=>c.querySelector(s);
  const qsa=(s,c=root)=>Array.from(c.querySelectorAll(s));
  const steps=[
    {n:1,name:'Logo',target:'#section-1',tab:'#btnSection-one'},
    {n:2,name:'Material',target:'#section-2',tab:'#btnSection-two'},
    {n:3,name:'Colors',target:'#section-3',tab:'#btnSection-three'},
    {n:4,name:'Cart',target:'#section-5',tab:'#btnSection-five'}
  ];
  let current=1;
  let unlocked=1;

  function updateNav(){
    const back=qs('#ccFlowBack'),next=qs('#ccFlowNext');
    const step=steps[current-1];
    if(qs('#ccFlowStepLabel')) qs('#ccFlowStepLabel').textContent=`Step ${current} of 4`;
    if(qs('#ccFlowStepName')) qs('#ccFlowStepName').textContent=step.name;
    if(back) back.disabled=current===1;
    if(next){
      next.textContent='Next Step →';
      next.disabled=false;
      next.hidden=current===4;
    }
    steps.forEach(s=>{
      const tab=qs(s.tab);
      if(!tab) return;
      const locked=s.n>unlocked;
      tab.classList.toggle('is-locked',locked);
      tab.classList.toggle('is-complete',s.n<unlocked);
      tab.setAttribute('aria-disabled',String(locked));
    });
    const add=qs('#add2cart');
    if(add){
      const ready=unlocked>=4;
      add.disabled=!ready;
      add.classList.toggle('is-flow-locked',!ready);
    }
  }

  function show(n){
    if(n<1||n>unlocked) return;
    current=n;
    const step=steps[n-1];
    qsa('.cc-section').forEach(sec=>sec.classList.toggle('is-active','#'+sec.id===step.target));
    qsa('#fxTabsDesktop .fx-tab').forEach(tab=>{
      const active=tab.matches(step.tab);
      tab.classList.toggle('active',active);
      tab.classList.toggle('bf-menu-selected',active);
      tab.setAttribute('aria-selected',String(active));
    });
    updateNav();
  }

  qs('#ccFlowNext')?.addEventListener('click',()=>{
    if(current>=4) return;
    unlocked=Math.max(unlocked,current+1);
    show(current+1);
  });
  qs('#ccFlowBack')?.addEventListener('click',()=>show(current-1));

  steps.forEach(step=>{
    const tab=qs(step.tab);
    if(!tab) return;
    tab.addEventListener('click',e=>{
      if(step.n>unlocked){
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      current=step.n;
      updateNav();
    },true);
  });

  updateNav();
})();

